export const GET_SETTING = 'CDL_INDIVIDUAL/get_setting';
export const GET_SINGLE_SETTING = 'CDL_INDIVIDUAL/get_single_setting';
export const UPDATE_PIN = 'CDL_INDIVIDUAL/update_setting';

export const FORM_DATA = {
  city_municipal: '',
  district: '',
};
